"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _CancelAPButton = _interopRequireDefault(require("../common/CancelAPButton"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('whitelist-address-form');
var WhiteListedAddressesList = function WhiteListedAddressesList(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('existing')
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('label-text')
  }, t("Existing addresses")), /*#__PURE__*/_react["default"].createElement("ul", {
    className: bemClasses('existing-list')
  }, props.whiteListedAddresses.map(function (i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: bemClasses('existing-address-item'),
      key: i.AccountWithdrawInfoId
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: bemClasses('existing-address-name')
    }, i.Name), /*#__PURE__*/_react["default"].createElement("span", {
      className: bemClasses('existing-address-address')
    }, i.AccountIdentifier), i.Verified ? /*#__PURE__*/_react["default"].createElement(_CancelAPButton["default"], {
      customClass: bemClasses('cancel-button'),
      text: " ",
      onClick: function onClick() {
        return props.DeleteAccountWithdrawInfo(i.AccountWithdrawInfoId);
      }
    }) : /*#__PURE__*/_react["default"].createElement("span", {
      className: bemClasses('info')
    }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: "info"
    }), t("Pending")));
  })));
};
var _default = exports["default"] = WhiteListedAddressesList;